/**
 * useNotificationSoundSocket — listener dedicado do canal `sound`.
 *
 * Escuta `NOTIFICATION_SOUND` (user-specific). O backend já fez todos os
 * gates (preferência, mute, recipient resolution) ANTES de emitir — presença
 * do evento = permissão pra tocar. Resolver de qual som tocar também é
 * backend (`resolveSoundKey` → `SoundKey`). Frontend só executa via mapping
 * `playSoundByKey`.
 *
 * Deve ser montado exatamente 1x no root da app (via `GlobalSocketListeners`).
 */

import { SOCKET_EVENTS as Events } from '@troia-v3/types';
import type { SoundNotificationEvent } from '@troia-v3/types';
import { useEffect } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { useSocket } from '@/contexts/SocketContext';
import { playSoundByKey } from '@/shared/utils/notificationSounds';

export const useNotificationSoundSocket = (): void => {
  const { socket } = useSocket();
  const { state: authState } = useAuth();

  useEffect(() => {
    if (!socket || !authState.user) return;

    const handler = (payload: SoundNotificationEvent): void => {
      playSoundByKey(payload.soundKey);
    };

    socket.on(Events.NOTIFICATION_SOUND, handler);
    return () => {
      socket.off(Events.NOTIFICATION_SOUND, handler);
    };
  }, [socket, authState.user]);
};
